import React, { FC, AnchorHTMLAttributes } from 'react'
import styled from 'styled-components'
import { breakpoints } from './Theme'
import { SpaceProps, space } from 'styled-system'
import { bodyRegularStyle } from './Typography/styles'
type Props = SpaceProps &
  AnchorHTMLAttributes<HTMLAnchorElement> & {
    image?: string
  }
const Link = styled.a<Props>`
  ${bodyRegularStyle};
  ${space};
  transition: border-color 0.25s ease-in-out;
  height: 3rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${p => p.theme.colors.shades[300]};
  border-radius: 4.5rem;
  white-space: nowrap;
  padding: 0 1rem;
  @media screen and (min-width: ${breakpoints.medium}) {
    height: 4rem;
    padding: 0 1.5rem;
  }
  &:hover,
  &:focus {
    border-color: ${p => p.theme.colors.shades[800]};
  }
`
const Image = styled.img`
  height: 1.5rem;
  width: auto;
  margin-right: 1rem;
`
export const CategoryLink: FC<Props> = React.forwardRef<HTMLAnchorElement, Props>(
  ({ image, children, mr = 3, ...rest }, ref) => {
    return (
      <Link mr={mr} ref={ref} {...rest}>
        {image && <Image src={image} alt="" />}
        {children}
      </Link>
    )
  }
)
export default CategoryLink
